import { createContext, useState } from "react";

export const ApprovalResultContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [approvalResultbhxhs, setApprovalResultbhxhs] = useState(null);
    const [approvalResultgplxs, setApprovalResultgplxs] = useState(null);
    const [approvalResultdkyxes, setApprovalResultdkyxes] = useState(null);
    const [approvalResultmsts, setApprovalResultmsts] = useState(null);
    const [approvalResultbhyts, setApprovalResultbhyts] = useState(null);

    const [approvalResultbhxh, setApprovalResultbhxh] = useState(null);
    const [approvalResultgplx, setApprovalResultgplx] = useState(null);
    const [approvalResultdkyxe, setApprovalResultdkyxe] = useState(null);
    const [approvalResultmst, setApprovalResultmst] = useState(null);
    const [approvalResultbhyt, setApprovalResultbhyt] = useState(null);

    // Make the context object:
    const approvalResultContext = {
        approvalResultbhxhs,
        setApprovalResultbhxhs,
        approvalResultgplxs,
        setApprovalResultgplxs,
        approvalResultdkyxes,
        setApprovalResultdkyxes,
        approvalResultmsts,
        setApprovalResultmsts,
        approvalResultbhyts,
        setApprovalResultbhyts,
        approvalResultbhxh,
        setApprovalResultbhxh,
        approvalResultgplx,
        setApprovalResultgplx,
        approvalResultdkyxe,
        setApprovalResultdkyxe,
        approvalResultmst,
        setApprovalResultmst,
        approvalResultbhyt,
        setApprovalResultbhyt,
    };

    // pass the value in provider and return
    return <ApprovalResultContext.Provider value={approvalResultContext}>{children}</ApprovalResultContext.Provider>;
};

export const { Consumer } = ApprovalResultContext;
